import {useTranslation} from "react-i18next";
import {format, isEqual} from "date-fns";
import { v4 as uuidv4 } from 'uuid';
import AdvertiseBlock from "../AdvertiseBlock";

export default function SideBlock(
    {
        id,
        dateStart,
        dateEnd,
        locations,
        organizers,
        countriesParticipants,
        phones,
        emails,
        sites
    }
) {
    const { t } = useTranslation();
    const dateStartDate = new Date(dateStart);
    const dateEndDate = new Date(dateEnd);
    const dateRange = isEqual(dateStartDate, dateEndDate) ?
        format(dateStartDate, 'dd.MM.y') :
        `${format(dateStartDate, 'dd.MM.y')} - ${format(dateEndDate, 'dd.MM.y')}`;
    const organizerNames = !!organizers.length ? organizers.map(organizer => organizer.name) : [];
    const countryNames = !!countriesParticipants.length ? countriesParticipants.map(country => country.name) : [];

    return (
        <div>
            <div className="conference-info">
                <div className="sub-info-block">
                    <h6>{ t('conferences.conference.when') }</h6>
                    { dateRange }
                </div>
                {
                    !!locations.length &&
                    <div className="sub-info-block locations">
                        <h6>{ t('conferences.conference.where') }</h6>
                        { locations.map(location => {
                            return (
                                <p key={uuidv4()}>
                                    { location.city }
                                    { !!location.street && `, ${ location.street }` }
                                    { !!location.house && `, ${ location.house }` }
                                    { !!location.name && <><br/>{ location.name }</> }
                                </p>
                            )
                        }) }
                        <a href="#location-map"
                           className="map-lnk">{ t('conferences.conference.showOnMap') }</a>
                    </div>
                }
                {
                    !!organizers.length &&
                    <div className="sub-info-block">
                        <h6>{ t('conferences.organizer') }</h6>
                        <p>
                            { organizerNames.join(', ') }
                        </p>
                    </div>
                }
                {
                    !!countriesParticipants.length &&
                    <div className="sub-info-block">
                        <h6>{ t('conferences.conference.countriesParticipants') }</h6>
                        <p>
                            { countryNames.join(', ') }
                        </p>
                    </div>
                }
                <div className="sub-info-block">
                    <h6>{ t('conferences.conference.contacts') }</h6>
                    <p>
                        { phones.map(phone => <>{ phone.phone }<br/></>) }
                    </p>
                </div>
                <div className="sub-info-block">
                    { emails.map(email => <><a href={`mailto:${email.email}`}>{email.email}</a><br/></>) }
                    { sites.map(site => <><a href={site.url}>{site.url}</a><br/></>) }
                </div>
            </div>
            <AdvertiseBlock
                unitId="conferencePage3"
                blockLocation="sidebar"
                entityId={id}
            />
        </div>

    );
}
